import { render, staticRenderFns } from "./progressBar.vue?vue&type=template&id=2bfd4e37&scoped=true&"
import script from "./progressBar.vue?vue&type=script&lang=js&"
export * from "./progressBar.vue?vue&type=script&lang=js&"
import style0 from "./progressBar.vue?vue&type=style&index=0&id=2bfd4e37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd4e37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfd4e37')) {
      api.createRecord('2bfd4e37', component.options)
    } else {
      api.reload('2bfd4e37', component.options)
    }
    module.hot.accept("./progressBar.vue?vue&type=template&id=2bfd4e37&scoped=true&", function () {
      api.rerender('2bfd4e37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/progressBar.vue"
export default component.exports